import script from "./GenericInstructions.vue?vue&type=script&setup=true&lang=js"
export * from "./GenericInstructions.vue?vue&type=script&setup=true&lang=js"

import "./GenericInstructions.vue?vue&type=style&index=0&id=6156221e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6156221e"]])

export default __exports__